var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.vereine,"items-per-page":_vm.itemsPerPage,"search":_vm.search,"footer-props":{'items-per-page-options': [5, 10, 15, -1]}},on:{"current-items":_vm.setFiltered}})
}
var staticRenderFns = []

export { render, staticRenderFns }